import React from 'react';
import { AlertCircle, X } from 'lucide-react';
import { Button } from './Button';
interface NonMondayStartModalProps {
  selectedDate: string;
  onKeepDate: () => void;
  onAlignMonday: () => void;
  onClose: () => void;
}
export function NonMondayStartModal({
  selectedDate,
  onKeepDate,
  onAlignMonday,
  onClose
}: NonMondayStartModalProps) {
  return <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-in fade-in duration-200" data-id="element-241">
      <div className="bg-white w-full max-w-sm rounded-[2.5rem] p-6 shadow-2xl animate-in zoom-in-95 duration-200 relative" data-id="element-242">
        <button onClick={onClose} className="absolute top-4 right-4 p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-colors" data-id="element-243">
          <X size={20} data-id="element-244" />
        </button>

        <div className="w-12 h-12 bg-amber-50 text-amber-500 rounded-full flex items-center justify-center mb-5 mx-auto" data-id="element-245">
          <AlertCircle size={24} data-id="element-246" />
        </div>

        <div className="text-center mb-6" data-id="element-247">
          <h2 className="text-2xl font-extrabold text-slate-800 mb-3" data-id="element-248">
            Start on this date?
          </h2>
          <p className="text-slate-500 font-medium text-sm leading-relaxed" data-id="element-249">
            This date does not start on Monday, so your training week will begin
            mid-week. You can keep this date, or align your program to the next
            Monday.
          </p>
        </div>

        <div className="space-y-3" data-id="element-250">
          <Button variant="primary" fullWidth onClick={onKeepDate} data-id="element-251">
            Keep this start date
          </Button>
          <Button variant="outline" fullWidth onClick={onAlignMonday} data-id="element-252">
            Align to next Monday
          </Button>
        </div>
      </div>
    </div>;
}